module.exports = __webpack_public_path__ + "static/media/New-Balance-Gray-Womens-990-V4-Running-Shoes-Lyst_thumb.f8b15c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/New-Balance-Gray-Womens-990-V4-Running-Shoes-Lyst_thumb.png
// module id = 307
// module chunks = 0